// @ts-check

import { ElementsBlocker, IFramesBlocker } from '../../vendor/ElementsBlocker/Blockers';

const elementsBlockerFolder = 'files/theme/js/modules/elementsBlocker';

function initializeBlocker() {
    new IFramesBlocker('.simply-blocked iframe', {
        button: {
            content: 'Akzeptieren',
        },
        logo: {
            source: `${elementsBlockerFolder}/icons/YouTubeLogo.svg`,
        },
        headline: {
            content: 'Blocked youtube element',
        },
        styles: `${elementsBlockerFolder}/inIframeStyles.css`,
        message: { content: 'Some Message' },
        caching: false,
    });

    new IFramesBlocker('.iframe-wetter', {
        button: {
            content: 'Akzeptieren',
        },
        logo: {
            source: `${elementsBlockerFolder}/icons/YouTubeLogo.svg`,
        },
        headline: {
            content: 'Blocked youtube element',
        },
        styles: `${elementsBlockerFolder}/inIframeStyles.css`,
        message: { content: 'Some Message' },
        caching: false,
    });

    new ElementsBlocker('.element-to-be-blocked .text_container', {
        headline: {
            content: "I'm Blocked",
        },
        button: {
            content: 'Accept',
        },
        onSubmit: [
            () => {
                alert('Accepted');
            },
            (element) => {
                element.innerText = "I'm unblocked now";
            },
        ],
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initializeBlocker();
});
